export const E_LABELS_ROUTE_NAME = 'accELabels'
export const eLabelTableName = 'eLabels'
